module.exports = __webpack_public_path__ + "media/סוס.fad726d2.mp3";